import { Expense } from "@finway-group/shared/lib/models"
import { DatePicker } from "antd"
import moment, { Moment } from "moment"
import React from "react"
import { useTranslation } from "react-i18next"

import { useCompany } from "Shared/hooks/company.hooks"
import { gobdNonCompliantDates } from "Shared/utils/date.utils"
import { getPopupAnchor } from "Shared/utils/popup.utils"

import { PostingPeriodInfoTooltip } from "../auxiliary/postingPeriodInfoTooltip"

interface PostingPeriodFormInterface {
    expense: Expense
    postingPeriod: Moment | null
    editable: boolean
    onChange: (value: Moment) => void
    onBlur: () => void
    isLoading?: boolean
}

export const PostingPeriodField = ({ expense, editable, postingPeriod, onChange, onBlur, isLoading }: PostingPeriodFormInterface) => {
    const company = useCompany()
    const { t } = useTranslation()

    if (!company.gobdCompliance?.enforceGobdCompliantInvoice) return null

    if (!editable || expense.isGobdCompliantInvoice()) {
        return (
            <li>
                <span className="title">
                    <div className="flex">
                        {t("label:posting_period")}
                        <PostingPeriodInfoTooltip />
                    </div>
                </span>
                <span className="text">{expense.postingPeriod ? moment(expense.postingPeriod).format("YYYY-MM") : "-"}</span>
            </li>
        )
    }

    return (
        <li>
            <span className="w-1/2 title">
                <div className="flex label-required">
                    {t("label:posting_period")}
                    <PostingPeriodInfoTooltip />
                </div>
            </span>

            <DatePicker
                className="w-1/2"
                picker="month"
                value={postingPeriod}
                format={t("label:date_format.month_year")}
                disabledDate={gobdNonCompliantDates}
                placeholder={t("placeholder:request.date_format.month_year")}
                onChange={onChange}
                onBlur={onBlur}
                getPopupContainer={getPopupAnchor()}
                disabled={isLoading}
            />
        </li>
    )
}
